import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useUserRoles } from "@/hooks/useUserRoles";
import { useToast } from "@/hooks/use-toast";

interface GlobalAdminProtectedRouteProps {
  children: React.ReactNode;
}

export const GlobalAdminProtectedRoute = ({ children }: GlobalAdminProtectedRouteProps) => {
  const { loading: authLoading, isSignedIn } = useAuth();
  const { loading: rolesLoading, isGlobalAdmin } = useUserRoles();
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    if (!authLoading && !rolesLoading) {
      if (!isSignedIn) {
        navigate("/auth/sign-in?source=global-admin-guard&next=%2Fglobal-admin%2Foverview", { replace: true });
      } else if (!isGlobalAdmin) {
        toast({
          title: "Access Denied",
          description: "You need platform administrator privileges to access this area.",
          variant: "destructive",
        });
        navigate("/train", { replace: true });
      }
    }
  }, [authLoading, rolesLoading, isSignedIn, isGlobalAdmin, navigate, toast]);

  if (authLoading || rolesLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-pulse text-2xl font-bold bg-gradient-to-r from-primary via-accent to-primary bg-clip-text text-transparent">
            Verifying admin access...
          </div>
        </div>
      </div>
    );
  }

  if (!isSignedIn || !isGlobalAdmin) {
    return null;
  }

  return <>{children}</>;
};
